"use client";
import ErrorBoundary from "@/components/ErrorBoundary";
import RenderModuleError from "@/components/site-builder/RenderModuleError";
import type { BaseSiteBuilderModule } from "@/types/site-builder";
import ModuleMapper from "../ModuleMapper";

export interface RenderPageContentProps {
  modules: BaseSiteBuilderModule[];
}

export default function RenderPageContent({ modules }: RenderPageContentProps) {
  return (
    <>
      {modules.map((module) => (
        <ErrorBoundary
          key={module.id}
          fallback={<RenderModuleError module={module} />}
        >
          <ModuleMapper module={module} />
        </ErrorBoundary>
      ))}
    </>
  );
}
